// Utilities
import { dataLayer } from "./dataLayer";
import timeStamp from "./timestamp";
import warn from "./warn";
import globalContext from "../utils/global";

// Helper from page module
import { getPageData } from "../modules/page";
import { GA_VERSION } from "../business/keys";
import { VERSION } from "../constants";

/**
 * @name reportError
 * @param {error} error - The error object
 * @return {void}
 */
export default function reportError(error) {
  warn(error);
  sendDataLayerByVersion(error, GA_VERSION.GA4);
}

/**
 * Build for the given GA version a payload and then send it to GA
 * @typedef {Function} sendDataLayerByVersion
 * @param  {object} [error] - Error data.
 * @param  {string} [gaversion] - Google Analytics version to build playload
 * @api private
 */
export function sendDataLayerByVersion(error, gaversion) {
  const { path } = getPageData();
  const { app, customerJourney } = globalContext.baseConfig;
  const errorPayload = buildErrorPayload(error);

  dataLayer({
    path,
    app,
    customerJourney,
    ...errorPayload,
    libVersion: VERSION,
    timestamp: timeStamp(),
    gaVersion: gaversion,
    event: "library",
  });
}

/**
 * Builder of error payload in GA4 format
 * @param  {object} [error] - Error data.
 * @return {object}
 */
const buildErrorPayload = (error) => {
  const name = error?.name ? error.name : "no-name";
  const message = error?.name
    ? error.message + ": " + error.params.originalValue
    : "no-path";

  return {
    parameters: {
      name: name,
      message: name == "ValidationError" ? message : "no-path",
    },
  };
};
